import { render } from "./CardRedeAtivos.vue?vue&type=template&id=54ad7c60"
import script from "./CardRedeAtivos.vue?vue&type=script&lang=js"
export * from "./CardRedeAtivos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/rhylton/Sites/intranet/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__